.root {
  margin-top: 1rem;
  border: 1px solid var(--mantine-color-gray-2, #e2e8f0);
  border-radius: 12px;
  background: var(--mantine-color-gray-0, #f8fafc);
  overflow: hidden;
}

.summary {
  cursor: pointer;
  padding: 0.75rem 1rem;
  font-weight: 600;
  color: var(--mantine-color-gray-6, #475569);
}

.body {
  padding: 0 1rem 1rem;
  display: grid;
  gap: 0.75rem;
  font-size: 0.875rem;
  color: var(--mantine-color-gray-7, #334155);
}
